import { CSSProperties } from 'react'

const CAMPAIGN_DIALOG_WIDTH = 1000

const campaignDialogStyle: CSSProperties = {
  width: CAMPAIGN_DIALOG_WIDTH,
  maxWidth: 'calc(100vw - 64px)',
  minWidth: 860,
  minHeight: 600,
  borderRadius: 15,
}

const campaignDialogContentStyle: CSSProperties = {
  borderTop: 'none',
  paddingTop: 5,
}

const voucherDialogContentStyle: CSSProperties = {
  ...campaignDialogContentStyle,
  paddingTop: 24,
}

export { campaignDialogStyle, campaignDialogContentStyle, voucherDialogContentStyle }
